import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SideBurgerHome } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { useNavigate } from 'react-router-dom';

interface IHomePageTab {
  closeAccordionTabs: Function;
}
export const HomePageTab = ({ closeAccordionTabs }: IHomePageTab) => {
  const navigate = useNavigate();
  return (
    <Stack
      direction='row'
      alignItems='center'
      gap='16px'
      sx={{
        height: '64px',
        pl: '24px',
        '&:hover , &:focus': {
          cursor: 'pointer',
          bgcolor: 'primary.shade_500',
          outline: 'none',
        },
      }}
      onClick={() => {
        closeAccordionTabs();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        navigate('/');
      }}
      onKeyDown={onEnterOrEscapeKeyDown}
      tabIndex={0}
      component='li'
    >
      <Avatar
        alt={''}
        src={SideBurgerHome}
        sx={{ width: '24px', height: '24px' }}
      />
      <Typography variant={'body4'}>
        {Dictionary[DICTIONARY.General].sidebar.home}
      </Typography>
    </Stack>
  );
};
